import React from 'react';
import { UserRolesAdmin } from './components';
import { Card, CardContent } from 'src/components';
const Security = () => {
  return (
    <Card className="relative">
      <CardContent className="p-6">
        <UserRolesAdmin />
      </CardContent>
    </Card>
  );
};

export default Security;
